import * as Turbo from "@hotwired/turbo"
import { Application } from "@hotwired/stimulus"

Turbo.start()

const application = Application.start()
application.debug = false

const modules = import.meta.glob("../controllers/*_controller.js", { eager: true })
for (const path in modules) {
  const match = path.match(/([a-z0-9_]+)_controller\.js$/)
  if (!match) continue
  const name = match[1].replace(/_/g, "-")
  application.register(name, modules[path].default)
}
